export function contactAsync(arg) {
  return $.post('/api/v1/contact/_contact', {
    contact_form: {
      name: arg.name,
      company: arg.company,
      email_address: arg.emailAddress,
      subject: arg.subject,
      message: arg.message,
      mobile: arg.mobile,
      send_media_kit: arg.sendMediaKit,
    },
  });
}

export function contactAsContributorAsync(arg) {
  return $.post('/api/v1/contact/_as_contributor', {
    contact_form: {
      name: arg.name,
      email_address: arg.emailAddress,
      mobile_phone_number: arg.mobilePhoneNumber,
    },
  });
}

export function contactAsPartnerAsync(arg) {
  return $.post('/api/v1/contact/_as_partner', {
    contact_form: {
      name: arg.name,
      email_address: arg.emailAddress,
      mobile_phone_number: arg.mobilePhoneNumber,
    },
  });
}
